import store from "../../redux/store";

const setToLocalStorage = function setToLocalStorage(value = '', name = store.getState().cookieName) {
    try {
        localStorage.setItem(name, value);
    } catch (e) {
        return false;
    }
};

export default setToLocalStorage;